"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sports = void 0;
var Sports;
(function (Sports) {
    Sports["NASCAR"] = "nascar";
    Sports["FOOTBALL"] = "football";
    Sports["BASKETBALL"] = "basketball";
    Sports["TENNIS"] = "tennis";
    Sports["ICE_HOCKEY"] = "ice_hockey";
    Sports["VOLLEYBALL"] = "volleyball";
    Sports["BASEBALL"] = "baseball";
    Sports["BEACH_VOLLEYBALL"] = "beach_volleyball";
    Sports["BOXING"] = "boxing";
    Sports["FUTSAL"] = "futsal";
    Sports["HANDBALL"] = "handball";
    Sports["MMA"] = "mma";
    Sports["SNOOKER"] = "snooker";
    Sports["MOTORSPORT"] = "motorsport";
    Sports["AMERICAN_FOOTBALL"] = "american_football";
    Sports["BEACH_SOCCER"] = "beach_soccer";
    Sports["AUSTRALIAN_RULES"] = "australian_rules";
    Sports["CHESS"] = "chess";
    Sports["DARTS"] = "darts";
    Sports["RUGBY_LEAGUE"] = "rugby_league";
    Sports["RUGBY"] = "rugby";
    Sports["SPECIALS"] = "specials";
    Sports["TABLE_TENNIS"] = "table_tennis";
    Sports["WATER_POLO"] = "water_polo";
    Sports["CYCLING"] = "cycling";
    Sports["BADMINTON"] = "badminton";
    Sports["FORMULA_1"] = "formula_1";
    Sports["BIATHLON"] = "biathlon";
    Sports["BANDY"] = "bandy";
    Sports["CROSS_COUNTRY"] = "cross_country";
    Sports["SKI_JUMPING"] = "ski_jumping";
    Sports["ALPINE_SKIING"] = "alpine_skiing";
    Sports["CURLING"] = "curling";
    Sports["HOCKEY"] = "hockey";
    Sports["OLYMPICS"] = "olympics";
    Sports["WRESTLING"] = "wrestling";
    Sports["ROWING"] = "rowing";
    Sports["CANOE_SLALOM"] = "canoe_slalom";
    Sports["CANOE_SPRINT"] = "canoe_sprint";
    Sports["JUDO"] = "judo";
    Sports["KARATE"] = "karate";
    Sports["EQUESTRIAN"] = "equestrian";
    Sports["SAILING"] = "sailing";
    Sports["SWIMMING"] = "swimming";
    Sports["DIVING"] = "diving";
    Sports["TRAMPOLINE"] = "trampoline";
    Sports["SURFING"] = "surfing";
    Sports["SYNCHRONIZED_SWIMMING"] = "synchronized_swimming";
    Sports["SKATEBOARDING"] = "skateboarding";
    Sports["MODERN_PENTATHLON"] = "modern_pentathlon";
    Sports["SOFTBALL"] = "softball";
    Sports["ARTISTIC_GYMNASTICS"] = "artistic_gymnastics";
    Sports["SPORT_CLIMBING"] = "sport_climbing";
    Sports["SHOOTING"] = "shooting";
    Sports["ARCHERY"] = "archery";
    Sports["TRIATHLON"] = "triathlon";
    Sports["TAEKWONDO"] = "taekwondo";
    Sports["WEIGHTLIFTING"] = "weightlifting";
    Sports["FENCING"] = "fencing";
    Sports["RHYTHMIC_GYMNASTICS"] = "rhythmic_gymnastics";
    Sports["BASKETBALL_3\u04253"] = "basketball_3\u04453";
    Sports["RUGBY_SEVENS"] = "rugby_sevens";
    Sports["ATHLETICS"] = "athletics";
    Sports["GOLF"] = "golf";
    Sports["CANOEING"] = "canoeing";
    Sports["BASKETBALL_3X3"] = "basketball_3x3";
    Sports["ESPORTS_ARTIFACT"] = "esports_artifact";
    Sports["ESPORTS_DOTA_AUTO_CHESS"] = "esports_dota_auto_chess";
    Sports["ESPORTS_DOTA_UNDERLORDS"] = "esports_dota_underlords";
    Sports["ESPORTS_FORMULA_1"] = "esports_formula_1";
    Sports["ESPORTS_ICE_HOCKEY"] = "esports_ice_hockey";
    Sports["ESPORTS_MORTAL_KOMBAT"] = "esports_mortal_kombat";
    Sports["ESPORTS_RACING"] = "esports_racing";
    Sports["ESPORTS_SPECIALS"] = "esports_specials";
    Sports["ESPORTS_TENNIS"] = "esports_tennis";
    Sports["ESPORTS_BOXING"] = "esports_boxing";
    Sports["ESPORTS_VOLLEYBALL"] = "esports_volleyball";
    Sports["ESPORTS_LEAGUE_OF_LEGENDS_WILD_RIFT"] = "esports_league_of_legends_wild_rift";
    Sports["ESPORTS_CALL_OF_DUTY"] = "esports_call_of_duty";
    Sports["ESPORTS_COUNTER_STRIKE"] = "esports_counter_strike";
    Sports["ESPORTS_DOTA_2"] = "esports_dota_2";
    Sports["ESPORTS_HEARTHSTONE"] = "esports_hearthstone";
    Sports["ESPORTS_HEROES_OF_THE_STORM"] = "esports_heroes_of_the_storm";
    Sports["ESPORTS_LEAGUE_OF_LEGENDS"] = "esports_league_of_legends";
    Sports["ESPORTS_OVERWATCH"] = "esports_overwatch";
    Sports["ESPORTS_STARCRAFT"] = "esports_starcraft";
    Sports["ESPORTS_WORLD_OF_TANKS"] = "esports_world_of_tanks";
    Sports["ESPORTS_STREET_FIGHTER_5"] = "esports_street_fighter_5";
    Sports["ESPORTS_VAINGLORY"] = "esports_vainglory";
    Sports["ESPORTS_WARCRAFT_3"] = "esports_warcraft_3";
    Sports["ESPORTS_RAINBOW_SIX"] = "esports_rainbow_six";
    Sports["ESPORTS_ROCKET_LEAGUE"] = "esports_rocket_league";
    Sports["ESPORTS_SMITE"] = "esports_smite";
    Sports["ESPORTS_SOCCER_MYTHICAL"] = "esports_soccer_mythical";
    Sports["ESPORTS_HALO"] = "esports_halo";
    Sports["ESPORTS_CROSSFIRE"] = "esports_crossfire";
    Sports["ESPORTS_BATTLEGROUNDS"] = "esports_battlegrounds";
    Sports["ESPORTS_FIFA"] = "esports_fifa";
    Sports["ESPORTS_STARCRAFT_1"] = "esports_starcraft_1";
    Sports["ESPORTS_KING_OF_GLORY"] = "esports_king_of_glory";
    Sports["ESPORTS_NBA_2K18"] = "esports_nba_2k18";
    Sports["ESPORTS_APEX_LEGENDS"] = "esports_apex_legends";
    Sports["ESPORTS_FORTNITE"] = "esports_fortnite";
    Sports["ESPORTS_BASKETBALL"] = "esports_basketball";
    Sports["ESPORTS_VALORANT"] = "esports_valorant";
    Sports["ESPORTS_CALL_OF_DUTY_WARZONE"] = "esports_call_of_duty_warzone";
    Sports["ESPORTS_MOBILE_LEGENDS_BANG_BANG"] = "esports_mobile_legends_bang_bang";
    Sports["ESPORTS_CLASH_ROYALE"] = "esports_clash_royale";
    Sports["ESPORTS_AGE_OF_EMPIRES"] = "esports_age_of_empires";
    Sports["ESPORTS_BRAWL_STARS"] = "esports_brawl_stars";
    Sports["ESPORTS_FREE_FIRE"] = "esports_free_fire";
    Sports["ESPORTS_QUAKE"] = "esports_quake";
    Sports["ESPORTS_WORLD_OF_WARCRAFT"] = "esports_world_of_warcraft";
    Sports["ESPORTS_CALL_OF_DUTY_MOBILE"] = "esports_call_of_duty_mobile";
    Sports["HORSE_RACING"] = "horse_racing";
    Sports["TRAMPOLINE_GYMNASTICS"] = "trampoline_gymnastics";
    Sports["CRICKET"] = "cricket";
})(Sports = exports.Sports || (exports.Sports = {}));
//# sourceMappingURL=sports.js.map